import { computed } from 'vue';
import { DashboardAccessItem } from '@/models/dashboard-data.interface';
import { TYPEFORM_URL } from '@/static/urls';
import DataTracker from '@/infrastructure/data-tracker';
import store from '@/store';

export default class IntroductionCode {

	public activeDashboardAvailable = computed((): boolean => {
		return this.activeDashboards.value.length > 0;
	});

	private activeDashboards = computed((): DashboardAccessItem[] => {
		return store.getters.activeDashboards();
	});

	private tracker = computed((): DataTracker => {
		return store.getters.tracker();
	});

	public handleRequestDemoClick(): void {
		this.tracker.value.trackRequestDemoClick('top_banner');
		window.open(TYPEFORM_URL, '_blank')?.focus();
	}
}
